export const IMAGES = {
  hero: "/gallery/lavoro-2.jpg",
  volume: "/gallery/lavoro-3.jpg",
  megaVolume: "/gallery/lavoro-1.jpg",
  laminazione: "/gallery/lavoro-4.jpg",
  laserPrima: "/gallery/laser-prima.jpg",
  laserDopo: "/gallery/laser-dopo.jpg",
  hollywood: "/gallery/hollywood.jpg",
  massage: "https://images.unsplash.com/photo-1706795033728-9232ef548a16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGZhY2lhbCUyMG1hc3NhZ2UlMjBzcGElMjBsdXh1cnl8ZW58MHx8fHwxNzkwMDY4MzMwfDA&ixlib=rb-4.1.0&q=85",
  salon2: "https://images.pexels.com/photos/7195800/pexels-photo-7195800.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PRICE_LIST = [
  {
    id: "extension",
    num: "01",
    category: "Extension Ciglia",
    note: "Tecnica UV — il nostro metodo signature",
    img: IMAGES.volume,
    items: [
      { name: "One to One", price: "€40", note: "Tecnica UV" },
      { name: "Volume", price: "€50", note: "Tecnica UV" },
      { name: "Mega Volume", price: "€60", note: "Tecnica UV" },
      { name: "Lash Flash", price: "€25", note: "Effetto rapido — durata 14-20 giorni" },
      { name: "Rimozione Extension", price: "€5" },
    ],
  },
  {
    id: "refill",
    num: "02",
    category: "Refill",
    note: "Consigliato ogni 3-4 settimane",
    img: IMAGES.megaVolume,
    items: [
      { name: "Refill One to One", price: "€30" },
      { name: "Refill Volume", price: "€40" },
      { name: "Refill Mega Volume", price: "€45" },
    ],
  },
  {
    id: "laminazione",
    num: "03",
    category: "Laminazione & Trattamenti",
    note: "Ciglia e sopracciglia",
    img: IMAGES.laminazione,
    items: [
      { name: "Laminazione Ciglia o Sopracciglia", price: "€35" },
      { name: "Combo Laminazione Ciglia + Sopracciglia", price: "€55" },
      { name: "Tinta Sopracciglia", price: "€15", note: "Durata circa 3 settimane" },
    ],
  },
  {
    id: "elettrostimolazione",
    num: "04",
    category: "Elettrostimolazione + Massaggio",
    note: "Tonifica, rassoda e drena — braccia, glutei, gambe, addome",
    img: IMAGES.massage,
    items: [
      { name: "Seduta Singola", price: "€30", note: "30 min elettrostimolatore + 15 min massaggio" },
      { name: "Pacchetto 12 Sedute", price: "€260", note: "Risparmi €100 · Pagabile in 3 comode rate" },
    ],
  },
  {
    id: "laser",
    num: "05",
    category: "Trattamenti Laser",
    note: "Previa valutazione in sede di consulto",
    img: IMAGES.laserDopo,
    items: [
      { name: "Rimozione Tatuaggi (piccoli e medi)", price: "da €80", note: "A seduta · sconti dedicati su pacchetti di sedute" },
      { name: "Rimozione Trucco Semipermanente (es. labbra)", price: "€65", note: "A seduta · solo su consulto con spot test sui pigmenti" },
      { name: "Hollywood Peel", price: "€80", note: "A seduta · tariffe agevolate acquistando un pacchetto" },
      { name: "Rimozione Macchie", price: "€40", note: "A seduta · previa valutazione in consulto" },
      { name: "Rimozione Rughe", price: "Su consulto", note: "Solo su consulto preventivo" },
      { name: "Rimozione Tattoo Sopracciglia", price: "Su consulto", note: "Valutazione gratuita in sede" },
    ],
  },
];

export const SERVICES = PRICE_LIST.flatMap((c) =>
  c.items.map((i, idx) => ({ id: `${c.id}-${idx}`, name: i.name, price: i.price }))
);

export const REVIEWS = [
  {
    name: "Giulia R.",
    text: "Le mie extension one to one sono perfette da settimane. Precisione e cura mai viste prima: non andrei da nessun'altra parte.",
    service: "Extension One to One",
  },
  {
    name: "Martina B.",
    text: "La laminazione ha trasformato le mie sopracciglia. Ambiente curatissimo, ti senti coccolata dal primo minuto.",
    service: "Laminazione",
  },
  {
    name: "Sara P.",
    text: "Massaggio con elettrostimolatore favoloso: esco ogni volta rigenerata. Professionalità e dolcezza assolute.",
    service: "Elettrostimolatore + Massaggio",
  },
];

export const CONTACT = {
  address: "Viale Giosuè Carducci 34/P, 41012 Carpi (MO)",
  phone: "+39 378 0010 746",
  phoneHref: "tel:+393780010746",
  email: "lash.queen.by.nat@gmail.com",
  emailHref: "mailto:lash.queen.by.nat@gmail.com",
  facebook: "Lash Queen Carpi",
  facebookHref: "https://www.facebook.com/LashQueenByNat/",
  whatsappHref: "https://wa.me/393780010746?text=Ciao%20Lash%20Queen!%20Vorrei%20informazioni%20su%20un%20trattamento.",
  hours: [
    { days: "Lunedì — Venerdì", time: "9:00 — 19:00" },
    { days: "Sabato", time: "9:00 — 17:00" },
    { days: "Domenica", time: "Chiuso" },
  ],
};
